export class TimelineSmsMessage {
  constructor(
    readonly id: string,
    readonly direction: 'inbound' | 'outbound',
    readonly body: string,
    readonly createdAt: string,
    readonly ownerId: string | null,
  ) {}
}
